module.exports = __webpack_public_path__ + "img/janet.5d765005.png";